module.exports = __webpack_public_path__ + "static/img/caseImg12.cb43a8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/caseImg12.jpg
// module id = ROpY
// module chunks = 0